export type HomePageRenderState = {
    tab: "events" | "communities" | "people" | "discover" | "none";

    setTab: (
        tab: "events" | "communities" | "people" | "discover" | "none",
    ) => void;

    clear: () => void;
};

export const homePageRenderStore = (
    set: (state: Partial<HomePageRenderState>) => void,
    get: () => HomePageRenderState,
): HomePageRenderState => ({
    tab: "events",

    setTab: (
        tab: "events" | "communities" | "people" | "discover" | "none",
    ) => {
        const currentState = get();

        if (currentState.tab !== tab) {
            set({ ...currentState, tab: tab });
        } else {
            set({ ...currentState, tab: "events" });
        }
    },

    clear: () => {
        set({
            tab: "events",
        });
    },
});
